export default {
  PREVIOUS_PAGE_URL: "previous-page-url",
  CURRENT_PAGE_URL: "current-page-url",

  REF_ENTER_ADD_GROUP_SITE_PUBLISHER: "ref-enter-add-group-site-publisher",
  REF_ENTER_ADD_GROUP_SITE_PUBLISHER_VALUE_ADD_CAMPAIGN: "add-campaign",
  REF_ENTER_ADD_GROUP_SITE_PUBLISHER_VALUE_ADD_GROUP: "add-group",

  GROUP_SITE_PUBLISHER_PAGE: "group-site-publisher-page",
  GROUP_SITE_PUBLISHER_SITE_NAME_SEARCH:
    "group-site-publisher-site-name-search",
  GROUP_SITE_PUBLISHER_CATEGORY_NAME_SEARCH_FILTER:
    "group-site-publisher-category-name-search-filter",
};
